var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Silhouettes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    height: 245,
    viewBox: "0 0 245 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .m2-cls1 {\n        fill: none;\n      }\n\n      .m2-cls2 {\n        fill: #ef7854;\n      }\n\n      .m2-cls3 {\n        clip-path: url(#m2-clippath-1);\n      }\n\n      .m2-cls4 {\n        fill: #ef7954;\n      }\n\n      .m2-cls5 {\n        clip-path: url(#m2-clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "m2-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m2-cls1",
    x: 195.44,
    y: 198.01,
    width: 41.61,
    height: 34.37,
    transform: "translate(-88.62 226.59) rotate(-47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m2-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m2-cls1",
    x: 14.05,
    y: 36.84,
    width: 22.04,
    height: 19.46,
    transform: "translate(-19.44 17.99) rotate(-29)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m2-cls4",
    d: "M234.02,137.8c-1-27-15-70-33-84s-34-32-75-33c0,0-85.49,32-108,74-15.51,28.94-21.04,61.68-8.58,88.73.41.54.72,1.16.93,1.79.03.09.05.19.07.28,5.7,11.38,14.68,21.69,27.58,30.2,44,29,49.97,29,79.99,29s50.01-23,70.01-41,47-39,46-66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_142",
    "data-name": "Groupe 142"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m2-cls5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141",
    "data-name": "Groupe 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233",
    "data-name": "Trac\\xE9 233",
    className: "m2-cls2",
    d: "M229.41,199.08c6.62,5.12,5.44,18.72-.25,27.04-5.83,8.52-16.19,12.99-25.65,5.55-6.57-5.16-10.01-14.38-3.37-24.1,5.69-8.32,21.37-14.6,29.27-8.49"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_144",
    "data-name": "Groupe 144"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m2-cls3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141-2",
    "data-name": "Groupe 141-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233-2",
    "data-name": "Trac\\xE9 233-2",
    className: "m2-cls2",
    d: "M34.31,40.56c2.64,3.93-.03,10.86-4.23,14.16-4.3,3.39-10.33,3.79-14.09-1.88-2.61-3.95-3-9.44,1.91-13.3,4.2-3.31,13.25-3.67,16.41,1.02"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M78.55,134.89c.53.96,6.28,19.19,6.62,20.96.78,4.05,1.17,13.02.05,16.75-.34,1.14-12.56,17.99-14.15,19.13-6.57,4.71-27.35,13.56-40.66,18.4,2.37,1.94,4.9,3.81,7.61,5.6,44,29,49.97,29,79.99,29,27.9,0,47.14-19.87,65.78-37.12-1.35-1.56-2.58-3.18-3.66-4.86-2.43-3.77-2.46-7.82-4.48-11.28-1.8-3.1-6.41-5.12-7.39-8.36-1.76-5.81,4.38-43.44,7.05-50.02,1.61-3.97,5.6-4.38,8.1-7.66,2.07-2.71,9.18-17.72,9.15-20.82-.05-5.38-4.55-6.19-5.38-10.49-2.76-14.22,3.61-32.01-3.91-46.88-1.6-3.15-5.49-5.07-6.28-7.73-1.76-5.98.75-21-4.28-26.38-.88-.94-21.58-10.12-23.6-10.54-14.55-3-46.25,4.09-58.87,12.15-22.24,14.21-19.26,47.57-18.74,70.72.09,4.25,2.11,8.31,2.01,12.23-.08,3.27-3.33,2.46-4.28,4.77-.55,1.34,3.62,25.92,4.39,28.22.76,2.26,3.86,2.23,4.94,4.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m2.bd61ce87219cde06b1b0f8f62a0512ed.svg";
export { ForwardRef as ReactComponent };